import { useContext, useEffect } from 'react';

import { AgentForgeBulkActivityContext } from './bulkActivityContext';

/** Selects exactly one activity. It never falls back to operation type, target,
 * recency, or any other heuristic that could attach the wrong progress row. */
export const useAgentForgeBulkActivity = (
  activityId: number,
  enabled = true
) => {
  const context = useContext(AgentForgeBulkActivityContext);
  const validActivityId = Number.isInteger(activityId) && activityId > 0;
  const watchActivity = context?.watchActivity;

  useEffect(() => {
    if (!enabled || !validActivityId || !watchActivity) return;
    return watchActivity(activityId);
  }, [activityId, enabled, validActivityId, watchActivity]);

  return {
    data: context?.getActivity(activityId),
    isUnavailable: context?.isActivityUnavailable(activityId) ?? false,
  };
};
